import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart'
import Service from './service';

class ChartView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false
    }

    componentDidMount () {
        Service.fetchSignUpSeriesWithPackageAndShipment(60);

        Service.event.onFetchSignUpStatsPerDayChartData.add((data) => {
            console.log("*** On fetch chart data");

            this.setState({
                renderChart : true,
                responseTableData: data,
                histogramChartCategoriesList: data.chartData.categoryList,
                histogramChartSeriesDataList1: data.chartData.seriesDataList1,
                histogramChartSeriesDataList2: data.chartData.seriesDataList2,
                histogramChartSeriesDataList3: data.chartData.seriesDataList3,
                seriesSignupsWithPackageWithinTwoWeeks: data.chartData.seriesSignupsWithPackageWithinTwoWeeks,
                seriesSignupsWithShipmentWithinFourWeeks: data.chartData.seriesSignupsWithShipmentWithinFourWeeks,
                totalSignUpsWithPackage: data.chartData.totalSignUpsWithPackage,

            });
        });
    }

    componentWillUnmount() {

    }

    render() {
        const options = {
            title: {
                text: 'Number of Sign Ups for the last two month'
            },
            xAxis: {
                categories: this.state.histogramChartCategoriesList
            },
            yAxis: {
                title: {
                    text: 'Number of sign ups'
                }
            },
            chart: {
                type: 'areaspline'
            },
            tooltip: {
                formatter: function(chartObject) {
                    var s = [];
                    s.push('<span style="font-size:11px"><b>Date:' + this.points[0].x + '</b></span><br>');
                    this.points.forEach(function(point, i) {
                        s.push('<span style="color:' + point.color + '; font-weight:bold;">'+ point.series.name +' : '+
                            point.y + '<span>');

                    });
                    //s.push('<span style="font-size:11px"><b>Sign Ups with Package in first 2 weeks(%): ' +
                    //    chartObject.options.percentageSignUpsWithPackageWithinTwoWeeks + '</b></span><br>');

                    return s.join('<br>');
                },
                shared: true
            },
            series: [{
                name: 'Daily Sign Ups',
                data: this.state.histogramChartSeriesDataList1
            },{
                name: 'Sign Ups with Package',
                data: this.state.histogramChartSeriesDataList2
            },{
                name: 'Sign Ups with Package within two weeks(%)',
                data: this.state.seriesSignupsWithPackageWithinTwoWeeks
            },{
                name: 'Sign Ups with Shipment',
                data: this.state.histogramChartSeriesDataList3
            },{
                name: 'Sign Ups with Shipment within four weeks(%)',
                data: this.state.seriesSignupsWithShipmentWithinFourWeeks
            }]
        };
        return (
            <div>
                { this.state.renderChart ? <CustomChart options={options}/> : '' }
            </div>
        );
    }
}

export default ChartView;